<template>
  <nav class="items-center relative">
    <div class="relative items-center relative h-full">
      <div class="absolute logo cursor-pointer h-full" @click="link('/')">
        <h1
          class="logo-bd clearfix h-full"
          :style="`background-image:url('${logoUrl}')`"
        >
          {{ title }}
        </h1>
      </div>
      <Menu
        mode="horizontal"
        :active-name="activeName"
        class="navbar h-full absolute"
      >
        <MenuItem
          v-for="(item, index) in navData"
          :key="`${item.id}_${index}`"
          :name="item.id"
          :to="item.children && item.children.length ? null : item.id"
        >
          <Dropdown
            v-if="item.children && item.children.length"
            @on-click="link"
          >
            {{ item.name }}
            <DropdownMenu slot="list">
              <template v-for="(child, index) in item.children">
                <Dropdown
                  v-if="child.children && child.children.length"
                  :key="`${child.id}_${index}`"
                  placement="right-start"
                  @on-click="link"
                >
                  <DropdownItem :name="child.id">
                    {{ child.name }}
                    <Icon type="ios-arrow-forward"></Icon>
                  </DropdownItem>
                  <DropdownMenu slot="list">
                    <DropdownItem
                      v-for="(val, index) in child.children"
                      :key="`${val.id}_${index}`"
                      :name="val.id"
                    >
                      {{ val.name }}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <DropdownItem
                  v-else
                  :key="`_${child.id}_${index}`"
                  :name="child.id"
                >
                  {{ child.name }}
                </DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
          <template v-else>{{ item.name }}</template>
        </MenuItem>
      </Menu>
    </div>
  </nav>
</template>

<script>
// import EventBus from '@/core/eventbus'

export default {
  name: 'header-nav',
  components: {},
  mixins: [],
  data() {
    return {
      activeName: '/',

      navData: [
        { id: '/', name: '首页' },
        {
          id: 'introduce',
          name: '中心介绍',
          children: [
            { id: 'sample', name: '湿库' },
            { id: 'information', name: '干库' }
          ]
        },
        {
          id: 'use1',
          name: '共享合作',
          children: [
            { id: 'IWant', name: '我要找资源' },
            { id: 'IWant', name: '我要用平台' },
            { id: 'share', name: '共享合作共识' },
            { id: 'retrieval', name: '高级检索' }
          ]
        },
        {
          id: 'achievements',
          name: '成果展示',
          children: [
            { id: 'achievement1', name: '学术荣誉与获奖' },
            { id: 'achievement2', name: '科研项目' },
            { id: 'achievement3', name: '发表论文' }
          ]
        },
        { id: 'news', name: '新闻热点' },
        {
          id: 'about',
          name: '关于我们',
          children: [
            { id: 'introduction', name: '中心介绍' },
            { id: 'direction', name: '理念与目标' },
            { id: 'organizational', name: '组织架构' },
            { id: 'history', name: '建设历程' }
          ]
        }
      ]
      // navData: [
      //   { id: '/', name: '首页' },
      //   { id: 'IWant', name: '我要用平台' },
      //   { id: 'information', name: '信息库' },
      //   { id: 'sample', name: '样本库' },
      //   { id: 'retrieval', name: '高级检索' },
      //   {
      //     id: 'about',
      //     name: '关于我们',
      //     children: [
      //       { id: 'introduction', name: '中心介绍' },
      //       {
      //         id: 'direction',
      //         name: '理念与目标'
      //       },
      //       { id: 'organizational', name: '组织架构' },
      //       { id: 'history', name: '建设历程' }
      //     ]
      //   }
      // ]
    }
  },
  watch: {
    $route(to) {
      if (to && to.name !== this.activeName) this.activeName = to.name
    }
  },
  computed: {
    logoUrl() {
      let url =
        this.$store.getters['HomeStore/logoUrl'] || './static/images/logo.png'
      return url
    },
    title() {
      return this.$store.getters['HomeStore/title']
    }
    // // navData() {
    // //   let data = this.$store.getters['CategoriesStore/categories']
    // //   if (!data) {
    // //     return
    // //   }
    // //   function visibleFilter(val) {
    // //     let res
    // //     res = val.filter(item => {
    // //       if (item.children && item.children.length !== 0) {
    // //         item.children = visibleFilter(item.children)
    // //       }
    // //       return item.visible === 1
    // //     })
    // //     return res
    // //   }
    // //   data = visibleFilter(data)
    // //   return data
    // // },
    // client() {
    //   let data = this.$store.getters['SubscriberStore/client']
    //   return data
    // },
    // subscriber() {
    //   let data = this.$store.getters['SubscriberStore/subscriber']
    //   return data
    // },
    // isLogin() {
    //   return (
    //     this.subscriber &&
    //     this.client &&
    //     this.subscriber.open_id &&
    //     this.client.mobile
    //   )
    // },
    // isAuthorize() {
    //   return this.client && this.subscriber && this.subscriber.open_id
    // },
    // navActiveId() {
    //   let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
    //   let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
    //     category
    //   )
    //   // 从breadcrumb第二项的ID 取 导航栏被选中的数据
    //   let navActive
    //   if (!breadcrumb || !breadcrumb[1]) {
    //     return
    //   }
    //   navActive = breadcrumb[1].id
    //   return navActive
    // }
  },
  mounted() {
    this.$router.onReady(() => {
      this.activeName = this.$route.name
    })

    // this.getClient()
    // EventBus.$on('showModal', () => {
    //   this.$set(this, 'showMask', true)
    // })
  },
  methods: {
    link(value) {
      // this.activeName = value
      // // eslint-disable-next-line no-console
      // console.log(value)

      this.$router.push({
        name: value
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
nav {
  height: 64px; //3.33vw;
  padding: 0 15.625vw; //0 300px;
}
.logo {
  left: 0;
  top: 13px; //0.68vw; //
  width: 20vw; //288px;
  height: 39px; //2vw;
  color: $c-transparent;
}
.logo-bd {
  background-size: auto 100%;
  background-repeat: no-repeat;
}
.navbar {
  right: 0;
}
.ivu-menu {
  display: inline-block;
  position: absolute;
}
.ivu-menu-horizontal {
  height: 100%;
}
@media only screen and (min-width: 736px) {
}
@media only screen and (max-width: 735px) {
  nav {
    display: none;
  }
}
</style>
